// @flow
import React, { Component } from 'react'
import Dropzone from 'react-dropzone'

import { Div, P, Span } from '@driftt/tide-core'
import { Icon } from '@driftt/tide-icons'

import { uploadCsv } from 'api/imports'

import './style.css'

class FileUpload extends Component {

  state = {
    file: null,
    upload: null,
    percentCompleted: 0
  }

  clear = () => {
    this.setState({
      file: null,
      upload: null,
      percentCompleted: 0
    }, this.props.onClear)
  }

  onUploadProgress = (progressEvent) => {
    const percentCompleted = Math.round( (progressEvent.loaded * 100) / progressEvent.total )
    this.setState({
      percentCompleted: percentCompleted
    })
  }

  onUpload = async () => {
    const { file } = this.state
    const { onUpload } = this.props
    const data = new FormData()
    data.append('file', file)

    try {
      const { data:upload } = await uploadCsv(data, this.onUploadProgress)
      onUpload(upload)

    } catch (err) {
      console.log(err)
    }
  }

  handleDrop = (acceptedFile, rejectedFile) => {
    const { name } = acceptedFile[0]

    if (acceptedFile[0] && name.endsWith('.csv')) {
      this.setState({
        file: acceptedFile[0]
      }, this.onUpload)
    }
  }

  render() {
    const { file } = this.state

    return (
      <Div>
        <Dropzone
          multiple={false}
          onDrop={this.handleDrop}
          disabled={!!file}
          className="contacts-import-drop"
          activeClassName="contacts-import-drop--active"
          rejectClassName="contacts-import-drop--reject"
          acceptClassName="contacts-import-drop--accept"
          disabledClassName="contacts-import-drop--disabled"
        >
          {!file &&
            <Div className="file-upload-drop-copy">
              <Icon name="upload-2" height={32} width={32} />
              <P>Drag & Drop a CSV here to upload <br />or<br/>
                <Span className="select-file">Select a file</Span>
              </P>
            </Div>
          }
          {file && 
            <Div className="file-upload-drop--dropped">
              <Icon name="check-circle" height={32} width={32} />
              <Div className="file-upload-drop--title-section">
                <P>{file.name}</P>
                <Span className="select-file" onClick={this.clear}>clear</Span>
              </Div>
            </Div>
          }

        </Dropzone>
      </Div>
    )
  }
}
export default FileUpload
